import { format, parseISO } from "date-fns";
import { IntelEntry, Jurisdiction } from "../data/intelligence";

const STOP_WORDS = new Set(["in", "the", "of", "for", "a", "an", "and", "to", "on", "how", "what", "do", "i"]);

export function formatUpdated(date: string, pattern = "MMM d, yyyy") {
  return format(parseISO(date), pattern);
}

export function buildJurisdictionOverviews(list: Jurisdiction[]): IntelEntry[] {
  return list.map((j) => ({
    id: `overview-${j.code.toLowerCase()}`,
    type: j.region === "us" ? "State guide" : "International guide",
    title: `${j.name} — Payroll overview`,
    jurisdiction: j.name,
    updated: j.updated,
    summary: `Registration, withholding, pay frequency, final pay, and leave requirements for employers in ${j.name}.`,
    keywords: [j.name.toLowerCase(), j.code.toLowerCase(), "requirements", "overview", "registration", "withholding"],
    facts: [
      { label: "Guides in library", value: String(j.guides) },
      { label: "Topics", value: "Registration · Withholding · Pay frequency · Final pay · Leave" },
    ],
    related: [],
  }));
}

export function searchEntries(query: string, entries: IntelEntry[]): IntelEntry[] {
  const terms = query
    .toLowerCase()
    .split(/[\s,.?]+/)
    .filter((t) => t.length > 1 && !STOP_WORDS.has(t));
  if (terms.length === 0) return [];

  const needed = Math.ceil(terms.length * 0.6);

  return entries
    .map((entry) => {
      const title = entry.title.toLowerCase();
      const body = [entry.summary, entry.jurisdiction ?? "", entry.type, ...entry.keywords].join(" ").toLowerCase();
      let score = 0;
      let matched = 0;
      terms.forEach((t) => {
        if (title.includes(t)) {
          score += 3;
          matched += 1;
        } else if (body.includes(t)) {
          score += 1;
          matched += 1;
        }
      });
      if (entry.id.startsWith("overview-")) score -= 0.5;
      return { entry, score, matched };
    })
    .filter((r) => r.matched >= needed && r.score > 0)
    .sort((a, b) => b.score - a.score)
    .map((r) => r.entry);
}
